import React from 'react'
import './projecttimeline.css'
import { Timeline, Events, UrlButton, ImageEvent } from "@merc/react-timeline";
import Accordion from 'react-bootstrap/Accordion'
import Css from '../../assets/skills/css3.svg'
import Html5 from '../../assets/skills/html-5.svg'
import Material_Ui from '../../assets/skills/material-ui-1.svg'
import React_L from '../../assets/skills/react.svg'
import Firebase_L from '../../assets/skills/firebasepng.png'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'
import ReactTodo from '../../assets/skills/react-todo.png'
import Redux_L from '../../assets/skills/redux.svg'
import Telegram_L from '../../assets/skills/telegram.png'
import Airbnb from '../../assets/skills/airbnb.jpg'
import ReactRout from '../../assets/skills/react-rout.png'
import Chart from '../../assets/skills/chart.webp'
import NodeJs from '../../assets/skills/nodejs.svg'
import Covid from '../../assets/skills/covidtracker.jpg'
import Netflix from '../../assets/skills/netflix.jpg'
import Axios_L from '../../assets/skills/axios.png'
import ConApi from '../../assets/skills/contextapi.png'
import Slack from '../../assets/skills/slacklogo.jpg'
import Snapchat from '../../assets/skills/snapchat-logo.jpg'


const ProjectTimeline = () => {
    return (
        <div id='projects'>
            <h1 className="pt-3 text-center font-details-b pb-3">PROJECTS</h1>
            <Timeline>
                <Events>
                    <ImageEvent
                        date="01/10/2020"
                        className="text-center"
                        text="Netflix Clone"
                        src={Netflix}
                        alt="Netflix Clone"
                    >
                        <div className="d-flex justify-content-between flex-column mt-1">
                        <div>
                            <Accordion>
                            <Card>
                                <Accordion.Toggle
                                as={Card.Header}
                                eventKey="0"
                                className="p-2 text-center accordian-main"
                                >
                                PROJECT DETAILS
                                </Accordion.Toggle>

                                <Accordion.Collapse eventKey="0" className="text-left">
                                <Card.Body>
                                    <strong>Description:</strong> This is a Netflix clone with react
                                    <hr />
                                    <strong>Features:</strong>
                                    <ul className="list-styles pt-1">
                                    <li>Keeps track movies</li>
                                    <li>Shows Trailers</li>
                                    <li>Respoisive Design</li>
                                    </ul>
                                    <hr />
                                    <strong>Tech used:</strong>
                                    <ul>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Html5}
                                            alt="HTML 5"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        HTML5
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Css}
                                            alt="CSS 3"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        CSS3
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={React_L}
                                            alt="React"
                                            rounded
                                            className="image-style1 m-1"
                                        ></Image>{" "}
                                        React
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Axios_L}
                                            alt="React Axios"
                                            rounded
                                            className="image-style1 m-1"
                                        ></Image>{" "}
                                        React Axios
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Firebase_L}
                                            alt="Firebase"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        Firebase
                                        </span>
                                    </li>
                                    </ul>
                                </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            </Accordion>
                        </div>
                        <div className="d-flex justify-content-between flex-nowrap text-center">
                            
                            <UrlButton
                            href="https://netflix-clone-ee24a.web.app/"
                            target="_blank"
                            className='button-url'
                            >
                            SEE LIVE
                            </UrlButton>
                            
                        </div>
                        </div>
                    </ImageEvent>
                    <ImageEvent
                        date="06/11/2020"
                        className="text-center"
                        text="Telegram App"
                        src={Telegram_L}
                        alt="Telegram App"
                    >
                        <div className="d-flex justify-content-between flex-column mt-1">
                        <div>
                            <Accordion>
                            <Card>
                                <Accordion.Toggle
                                as={Card.Header}
                                eventKey="0"
                                className="p-2 text-center accordian-main"
                                >
                                PROJECT DETAILS
                                </Accordion.Toggle>

                                <Accordion.Collapse eventKey="0" className="text-left">
                                <Card.Body>
                                    <strong>Description:</strong> This is a Telegram Clone with uer authentication 
                                    <hr />
                                    <strong>Features:</strong>
                                    <ul className="list-styles pt-1">
                                    <li>Ability to login/logout with firebase auth</li>
                                    <li>Powered by React and Redux</li>
                                    <li>Respoisive Design</li>
                                    </ul>
                                    <hr />
                                    <strong>Tech used:</strong>
                                    <ul>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Html5}
                                            alt="HTML 5"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        HTML5
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Css}
                                            alt="CSS 3"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        CSS3
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={React_L}
                                            alt="React"
                                            rounded
                                            className="image-style1 m-1"
                                        ></Image>{" "}
                                        React
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Material_Ui}
                                            alt="Material-UI"
                                            rounded
                                            className="image-style1 m-1"
                                        ></Image>{" "}
                                        Material-UI
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Firebase_L}
                                            alt="Firebase"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        Firebase
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Redux_L}
                                            alt="redux"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        Redux
                                        </span>
                                    </li>
                                    </ul>
                                </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            </Accordion>
                        </div>
                        <div className="d-flex justify-content-between flex-nowrap text-center">
                            
                            <UrlButton
                            href="https://telegram-clone-2c0be.web.app/"
                            target="_blank"
                            className='button-url'
                            >
                            SEE LIVE
                            </UrlButton>
                            
                        </div>
                        </div>
                    </ImageEvent>
                    <ImageEvent
                        date="08/12/2020"
                        className="text-center"
                        text="Airbnb App"
                        src={Airbnb}
                        alt="Airbnb App"
                    >
                        <div className="d-flex justify-content-between flex-column mt-1">
                        <div>
                            <Accordion>
                            <Card>
                                <Accordion.Toggle
                                as={Card.Header}
                                eventKey="0"
                                className="p-2 text-center accordian-main"
                                >
                                PROJECT DETAILS
                                </Accordion.Toggle>

                                <Accordion.Collapse eventKey="0" className="text-left">
                                <Card.Body>
                                    <strong>Description:</strong> This is an Airbnb Front-end Clone with React Router 
                                    <hr />
                                    <strong>Features:</strong>
                                    <ul className="list-styles pt-1">
                                    <li>Ability to go to other links</li>
                                    <li>Powered by React and React Router </li>
                                    <li>Respoisive Design with material UI and Flex-Box</li>
                                    </ul>
                                    <hr />
                                    <strong>Tech used:</strong>
                                    <ul>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Html5}
                                            alt="HTML 5"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        HTML5
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Css}
                                            alt="CSS 3"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        CSS3
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={React_L}
                                            alt="React"
                                            rounded
                                            className="image-style1 m-1"
                                        ></Image>{" "}
                                        React
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Material_Ui}
                                            alt="Material-UI"
                                            rounded
                                            className="image-style1 m-1"
                                        ></Image>{" "}
                                        Material-UI
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Firebase_L}
                                            alt="Firebase"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        Firebase
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={ReactRout}
                                            alt="react router"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        React Router
                                        </span>
                                    </li>
                                    </ul>
                                </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            </Accordion>
                        </div>
                        <div className="d-flex justify-content-between flex-nowrap text-center">
                            
                            <UrlButton
                            href="https://airbnb-clone-32c66.web.app/"
                            target="_blank"
                            className='button-url'
                            >
                            SEE LIVE
                            </UrlButton>
                            
                        </div>
                        </div>
                    </ImageEvent>
                    
                    <ImageEvent
                        date="12/12/2020"
                        className="text-center"
                        text="Covid-19 Tracker App"
                        src={Covid}
                        alt="Covid-19 Tracker App"
                    >
                        <div className="d-flex justify-content-between flex-column mt-1">
                        <div>
                            <Accordion>
                            <Card>
                                <Accordion.Toggle
                                as={Card.Header}
                                eventKey="0"
                                className="p-2 text-center accordian-main"
                                >
                                PROJECT DETAILS
                                </Accordion.Toggle>

                                <Accordion.Collapse eventKey="0" className="text-left">
                                <Card.Body>
                                    <strong>Description:</strong> This is an Covid 19 tracker which shows real time corona virus data using node js and chart js
                                    <hr />
                                    <strong>Features:</strong>
                                    <ul className="list-styles pt-1">
                                    <li>Ability to show real time corona virus data </li>
                                    <li>Powered by React and NodeJs </li>
                                    <li>Respoisive Design with material UI and Flex-Box</li>
                                    <l1>Chart Js for displaying data in chart and react-Leaflet for the map </l1>
                                    </ul>
                                    <hr />
                                    <strong>Tech used:</strong>
                                    <ul>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Html5}
                                            alt="HTML 5"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        HTML5
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Css}
                                            alt="CSS 3"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        CSS3
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={React_L}
                                            alt="React"
                                            rounded
                                            className="image-style1 m-1"
                                        ></Image>{" "}
                                        React
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Material_Ui}
                                            alt="Material-UI"
                                            rounded
                                            className="image-style1 m-1"
                                        ></Image>{" "}
                                        Material-UI
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Firebase_L}
                                            alt="Firebase"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        Firebase
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Chart}
                                            alt="Chart Js"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        Chart JS
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={NodeJs}
                                            alt="Node Js"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        Node JS
                                        </span>
                                    </li>
                                    </ul>
                                </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            </Accordion>
                        </div>
                        <div className="d-flex justify-content-between flex-nowrap text-center">
                            
                            <UrlButton
                            href="https://covid19-updated.web.app/"
                            target="_blank"
                            className='button-url'
                            >
                            SEE LIVE
                            </UrlButton>
                            
                        </div>
                        </div>
                    </ImageEvent>
                    <ImageEvent
                        date="12/1/2020"
                        className="text-center"
                        text="Slack"
                        src={Slack}
                        alt="Slack"
                    >
                        <div className="d-flex justify-content-between flex-column mt-1">
                        <div>
                            <Accordion>
                            <Card>
                                <Accordion.Toggle
                                as={Card.Header}
                                eventKey="0"
                                className="p-2 text-center accordian-main"
                                >
                                PROJECT DETAILS
                                </Accordion.Toggle>

                                <Accordion.Collapse eventKey="0" className="text-left">
                                <Card.Body>
                                    <strong>Description:</strong> This is a Slack App which shows channels and the messages inside the channel
                                    <hr />
                                    <strong>Features:</strong>
                                    <ul className="list-styles pt-1">
                                    <li>Ability to show messages of each channel </li>
                                    <li>Create new channels </li>
                                    <li>Respoisive Design with material UI and Flex-Box</li>
                                    <l1>Firebase for database </l1>
                                    </ul>
                                    <hr />
                                    <strong>Tech used:</strong>
                                    <ul>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Html5}
                                            alt="HTML 5"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        HTML5
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Css}
                                            alt="CSS 3"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        CSS3
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={React_L}
                                            alt="React"
                                            rounded
                                            className="image-style1 m-1"
                                        ></Image>{" "}
                                        React
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Material_Ui}
                                            alt="Material-UI"
                                            rounded
                                            className="image-style1 m-1"
                                        ></Image>{" "}
                                        Material-UI
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Firebase_L}
                                            alt="Firebase"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        Firebase
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={ConApi}
                                            alt="React Context Api"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        React Context Api
                                        </span>
                                    </li>
                                    </ul>
                                </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            </Accordion>
                        </div>
                        <div className="d-flex justify-content-between flex-nowrap text-center">
                            
                            <UrlButton
                            href="https://slack-clone-d0fd8.web.app/"
                            target="_blank"
                            className='button-url'
                            >
                            SEE LIVE
                            </UrlButton>
                            
                        </div>
                        </div>
                    </ImageEvent>
                    <ImageEvent
                        date="31/1/2021"
                        className="text-center"
                        text="Snapchat"
                        src={Snapchat}
                        alt="Snapchat"
                    >
                        <div className="d-flex justify-content-between flex-column mt-1">
                        <div>
                            <Accordion>
                            <Card>
                                <Accordion.Toggle
                                as={Card.Header}
                                eventKey="0"
                                className="p-2 text-center accordian-main"
                                >
                                PROJECT DETAILS
                                </Accordion.Toggle>

                                <Accordion.Collapse eventKey="0" className="text-left">
                                <Card.Body>
                                    <strong>Description:</strong> This is an Snapchat clone which shows real time snaps
                                    <hr />
                                    <strong>Features:</strong>
                                    <ul className="list-styles pt-1">
                                    <li>Ability to show real time snaps </li>
                                    <li>with react webcam one can tke pics </li>
                                    <li>Respoisive Design with material UI and Flex-Box</li>
                                    <l1>Send and view snaps </l1>
                                    </ul>
                                    <hr />
                                    <strong>Tech used:</strong>
                                    <ul>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Html5}
                                            alt="HTML 5"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        HTML5
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Css}
                                            alt="CSS 3"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        CSS3
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={React_L}
                                            alt="React"
                                            rounded
                                            className="image-style1 m-1"
                                        ></Image>{" "}
                                        React
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Material_Ui}
                                            alt="Material-UI"
                                            rounded
                                            className="image-style1 m-1"
                                        ></Image>{" "}
                                        Material-UI
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Firebase_L}
                                            alt="Firebase"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        Firebase
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={ReactRout}
                                            alt="Chart Js"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        React Router
                                        </span>
                                    </li>
                                    <li>
                                        <span className="p-2">
                                        <Image
                                            src={Redux_L}
                                            alt="Redux"
                                            rounded
                                            className="image-style m-1"
                                        ></Image>{" "}
                                        Redux
                                        </span>
                                    </li>
                                    </ul>
                                </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            </Accordion>
                        </div>
                        <div className="d-flex justify-content-between flex-nowrap text-center">
                            
                            <UrlButton
                            href="https://snapchat-dc1d9.web.app/"
                            target="_blank"
                            className='button-url'
                            >
                            SEE LIVE
                            </UrlButton>
                            
                        </div>
                        </div>
                    </ImageEvent>
                </Events>
            </Timeline>
        </div>
    )
}

export default ProjectTimeline
